import { useTranslation } from 'react-i18next';

import { AnimatedRoutedDrawer } from 'src/Components/Drawers/AnimatedRoutedDrawer';
import { InventoryItemCreationFormWrapper } from 'src/Components/Forms/Inventory/InventoryItemCreationFormWrapper';
import { useCurrentAssetId } from 'src/Hooks/Shared/useCurrentAssetId';

const CreateInventoryItemDrawer = () => {
  const { t } = useTranslation();
  const assetId = useCurrentAssetId();

  return (
    <AnimatedRoutedDrawer
      title={t('inventory.add.cta', 'Ajouter un objet')}
      to={`/asset/${assetId}/inventories`}
    >
      {({ onClose }) => <InventoryItemCreationFormWrapper onClose={onClose} />}
    </AnimatedRoutedDrawer>
  );
};

export default CreateInventoryItemDrawer;
